var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var EnumDefinition = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print,
        options = _ref.options;
    return group(concat(['enum ', node.name, ' {', indent(concat([options.bracketSpacing ? line : softline, join(concat([',', line]), path.map(_print, 'members'))])), options.bracketSpacing ? line : softline, '}']));
  }
};
module.exports = EnumDefinition;